import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'

const TRAINING_CLASS_NAMES = [
  EXERCISE_CLASS_NAME
]

export {
  TRAINING_CLASS_NAMES
}
